/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Status_DoneInputs */



/**
* | output |
* | --- |
* | "Done" |
*
* @param {Team_Sync_Status_DoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_status_done = /** @type {((inputs?: Team_Sync_Status_DoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Status_DoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erledigt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fatto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сделанный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hecho")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("完毕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終わり")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Feito")
	return /** @type {LocalizedString} */ ("Done")
});